<template>
  	<!-- 底部 -->
  	<div class="container">
		<div class="left" ></div>

		<div class="center">
			<div class="content-wrapper flex_items">
				<el-image :src="logo" class="logo"></el-image>
				<div class="name">
					<div class="name_line">厦门市佐云佑网科技有限公司</div>
					<div class="name_line">厦门市集美区软件园三期F10</div>
				</div>
			</div>

			<div class="content-wrapper vue-flex">
				<div class="connect" style="margin: 0 120px;">
					<div style="margin-bottom: 6px;">联系我们</div>
					<div>电话：18959215659</div>
					<div>邮箱：zo-cloud@zocloud.com</div>
				</div>
			</div>
			<div class="content-wrapper vue-flex">
				<div class="connect">
					<div>Copyright &copy; 2024 佐云科技 All Rights Reserved</div>
					<a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备 2022017262号</a>
					<div>
						<el-image :src="beian" style="width: 15px;margin: 0 3px -5px 0 ;"></el-image>
						<a href="https://beian.mps.gov.cn/#/query/webSearch?code=35021102002086" rel="noreferrer" target="_blank">闽公网安备 35021102002086号</a>
					</div>
				</div>
			</div>
		</div>

		<div class="right" ></div>
	</div>
</template>

<script>
export default {
    data() {
        return {
			logo: require('@/assets/dblogo.png'),
			beian: require('@/assets/beian.png'),
        }
    },
	created() {
		
	},
    methods: {
		
	},
}
</script>

<style lang="scss" scoped>
.container{
	display: flex;
	flex-direction: row;
	flex: 1;
}
.center{
	flex: 0 0 1200px;
	height: 160px;
	background-color: #1A3A67;
	color: #FFFFFF;
	display: flex;
	align-items: center;// 垂直居中

	justify-content: center;  
}
.left,.right{
	flex: 1;
	height: 160px;
	background-color: #1A3A67;
}

.content-wrapper {
	// width: 420px;
	height: 100px;
}

// .content-wrapper:not(:last-child) {
// 	// border-right: 1px solid #1E4474;
// 	// height: calc(50% - 4px); /* 4px 是边框的宽度乘以2 */
//     // box-sizing: border-box; /* 让边框宽度包含在元素的总宽度中 */
// }

.logo{
	width: 200px;
	height: 40px;
}

.name{
	font-size: 14px;
	margin-left: 35px;
	align-self: center;
	.name_line{
		line-height: 25px;
	}
}

.connect {
	// margin: 0 0 0 100px;
	align-self: center;
	font-size: 14px;
}

.wx{
	width: 60px;
	height: 60px;
	align-self: center;
}
a{
  text-decoration: none;
  color:white;
}
</style>